export default "__VITE_ASSET__CFulqcIF__"